module.exports = __webpack_public_path__ + "img/dcmm_2.9f8ea8ea.png";